import { render, staticRenderFns } from "./valuation-request.vue?vue&type=template&id=8d045d36"
import script from "./valuation-request.vue?vue&type=script&lang=js"
export * from "./valuation-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports